module.exports = __webpack_public_path__ + "img/吴志友.7b7193ba.jpg";